"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ThemeProvider = void 0;
exports.useColorSchemeVar = useColorSchemeVar;
exports.useTheme = useTheme;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _theme = _interopRequireDefault(require("../styles/theme"));
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// import 'react-toastify/dist/ReactToastify.css';
// import 'react-datepicker/dist/react-datepicker.css';
// TODO: Use cssModule and add webpack configuration for css-loader
// import '@maersk-global/fonts/maeu/fonts-cdn.css';
// import '@maersk-global/icons/fonts/web/20px/icons.min.css';
// import '@maersk-global/icons/fonts/web/24px/icons.min.css';
// import 'tippy.js/dist/tippy.css';
// import 'tippy.js/themes/light-border.css';
// import GlobalCSS from './global.css';
const defaultColorMode = 'day';
const defaultDayScheme = 'light';
const defaultNightScheme = 'dark';
const ThemeContext = /*#__PURE__*/_react["default"].createContext({
  setColorMode: () => null,
  setDayScheme: () => null,
  setNightScheme: () => null
});
const ThemeProvider = _a => {
  var _b, _c, _d, _e, _f, _g, _h, _j;
  var {
      children
    } = _a,
    props = __rest(_a, ["children"]);
  // Get fallback values from parent ThemeProvider (if exists)
  const {
    theme: fallbackTheme,
    colorMode: fallbackColorMode,
    dayScheme: fallbackDayScheme,
    nightScheme: fallbackNightScheme
  } = useTheme();
  // Initialize state
  const theme = (_c = (_b = props.theme) !== null && _b !== void 0 ? _b : fallbackTheme) !== null && _c !== void 0 ? _c : _theme["default"];
  const [colorMode, setColorMode] = _react["default"].useState((_e = (_d = props.colorMode) !== null && _d !== void 0 ? _d : fallbackColorMode) !== null && _e !== void 0 ? _e : defaultColorMode);
  const [dayScheme, setDayScheme] = _react["default"].useState((_g = (_f = props.dayScheme) !== null && _f !== void 0 ? _f : fallbackDayScheme) !== null && _g !== void 0 ? _g : defaultDayScheme);
  const [nightScheme, setNightScheme] = _react["default"].useState((_j = (_h = props.nightScheme) !== null && _h !== void 0 ? _h : fallbackNightScheme) !== null && _j !== void 0 ? _j : defaultNightScheme);
  const systemColorMode = useSystemColorMode();
  const resolvedColorMode = resolveColorMode(colorMode, systemColorMode);
  const colorScheme = chooseColorScheme(resolvedColorMode, dayScheme, nightScheme);
  const resolvedTheme = _react["default"].useMemo(() => applyColorScheme(theme, colorScheme), [theme, colorScheme]);
  // Update state if props change
  _react["default"].useEffect(() => {
    var _a, _b;
    setColorMode((_b = (_a = props.colorMode) !== null && _a !== void 0 ? _a : fallbackColorMode) !== null && _b !== void 0 ? _b : defaultColorMode);
  }, [props.colorMode, fallbackColorMode]);
  _react["default"].useEffect(() => {
    var _a, _b;
    setDayScheme((_b = (_a = props.dayScheme) !== null && _a !== void 0 ? _a : fallbackDayScheme) !== null && _b !== void 0 ? _b : defaultDayScheme);
  }, [props.dayScheme, fallbackDayScheme]);
  _react["default"].useEffect(() => {
    var _a, _b;
    setNightScheme((_b = (_a = props.nightScheme) !== null && _a !== void 0 ? _a : fallbackNightScheme) !== null && _b !== void 0 ? _b : defaultNightScheme);
  }, [props.nightScheme, fallbackNightScheme]);
  return (0, _jsxRuntime.jsx)(ThemeContext.Provider, (0, _extends2["default"])({
    value: {
      theme: resolvedTheme,
      colorScheme,
      colorMode,
      resolvedColorMode,
      dayScheme,
      nightScheme,
      setColorMode,
      setDayScheme,
      setNightScheme
    }
  }, {
    children: (0, _jsxRuntime.jsx)(_styledComponents.ThemeProvider, (0, _extends2["default"])({
      theme: resolvedTheme
    }, {
      children: children
    }))
  }));
};
exports.ThemeProvider = ThemeProvider;
function useTheme() {
  return _react["default"].useContext(ThemeContext);
}
function useColorSchemeVar(values, fallback) {
  var _a;
  const {
    colorScheme = ''
  } = useTheme();
  return (_a = values[colorScheme]) !== null && _a !== void 0 ? _a : fallback;
}
function useSystemColorMode() {
  const [systemColorMode, setSystemColorMode] = _react["default"].useState(getSystemColorMode);
  _react["default"].useEffect(() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const media = (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-color-scheme: dark)');
    function handleChange(event) {
      const isNight = event.matches;
      setSystemColorMode(isNight ? 'night' : 'day');
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (media) {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (media.addEventListener !== undefined) {
        media.addEventListener('change', handleChange);
        return function cleanup() {
          media.removeEventListener('change', handleChange);
        };
      }
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      else if (media.addListener !== undefined) {
        media.addListener(handleChange);
        return function cleanup() {
          media.removeListener(handleChange);
        };
      }
    }
  }, []);
  return systemColorMode;
}
function getSystemColorMode() {
  var _a, _b;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (typeof window !== 'undefined' && ((_b = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-color-scheme: dark)')) === null || _b === void 0 ? void 0 : _b.matches)) {
    return 'night';
  }
  return 'day';
}
function resolveColorMode(colorMode, systemColorMode) {
  switch (colorMode) {
    case 'auto':
      return systemColorMode;
    default:
      return colorMode;
  }
}
function chooseColorScheme(colorMode, dayScheme, nightScheme) {
  switch (colorMode) {
    case 'day':
      return dayScheme;
    case 'night':
      return nightScheme;
  }
}
function applyColorScheme(theme, colorScheme) {
  if (!theme.colorSchemes) {
    return theme;
  }
  if (!theme.colorSchemes[colorScheme]) {
    // eslint-disable-next-line no-console
    console.error("`".concat(colorScheme, "` scheme not defined in `theme.colorSchemes`"));
    // Apply the first defined color scheme
    const defaultColorScheme = Object.keys(theme.colorSchemes)[0];
    return (0, _deepmerge["default"])(theme, theme.colorSchemes[defaultColorScheme]);
  }
  return (0, _deepmerge["default"])(theme, theme.colorSchemes[colorScheme]);
}
var _default = exports["default"] = ThemeProvider;